<template>
  <div>
    <el-breadcrumb>
      <el-breadcrumb-item><router-link to="/">首页</router-link></el-breadcrumb-item>
      <el-breadcrumb-item>弹窗管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <el-form inline label-width="60px" size="small" class="query-form" @submit.native.prevent="selClick">
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="标题"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selClick">查询</el-button>
          <el-button type="success" @click="addClick">新增</el-button>
        </el-form-item>
      </el-form>
      <el-card class="box-card table">
        <div slot="header"><span>弹窗列表</span></div>
        <el-tabs v-model="query.popupType" @tab-click="selClick">
          <el-tab-pane label="全部" name="0"></el-tab-pane>
          <el-tab-pane label="首页" name="home"></el-tab-pane>
          <el-tab-pane label="个人中心" name="5"></el-tab-pane>
          <el-tab-pane
            v-for="item in homeTypeList"
            :key="item.id"
            :label="'首页·' + item.name"
            :name="item.id.toString()"
          ></el-tab-pane>
        </el-tabs>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="title" label="标题" min-width="140"></el-table-column>
          <el-table-column label="展示位置" width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.popupType == 5" type="warning" size="mini">个人中心</el-tag>
              <el-tag v-else type="success" size="mini">首页</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="类型" width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{ typeName(scope.row.popupType) }}</template>
          </el-table-column>
          <el-table-column label="适用用户" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.popupType == 5">{{ audienceName(scope.row.audience) }}</span>
              <span v-else class="muted">—</span>
            </template>
          </el-table-column>
          <el-table-column label="图片" width="100">
            <template slot-scope="scope">
              <img v-if="scope.row.imgUrl" :src="domain + scope.row.imgUrl" style="height:50px" />
            </template>
          </el-table-column>
          <el-table-column prop="startDate" label="开始" width="160"></el-table-column>
          <el-table-column prop="endDate" label="结束" width="160"></el-table-column>
          <el-table-column prop="sort" label="排序" width="70"></el-table-column>
          <el-table-column label="启用" width="70">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isEnable" type="success">是</el-tag>
              <el-tag v-else type="info">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
              <el-button type="text" style="color:#f56c6c" @click="delClick(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="margin-top:20px">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10,20,30,50]" :page-size="pageSize"
            layout="total,prev,sizes,pager,next,jumper" :total="total"></el-pagination>
        </div>
      </el-card>
    </div>

    <el-dialog :title="form.id > 0 ? '编辑弹窗' : '添加弹窗'" :visible.sync="dialogVisible" width="720px" @opened="dialogOpened">
      <el-form :model="form" ref="form" label-width="120px" @submit.native.prevent="submitForm">
        <el-form-item label="标题" prop="title" :rules="[{ required: true, message: '请输入标题' }]">
          <el-input v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="展示位置" prop="showPlace" :rules="[{ required: true, message: '请选择' }]">
          <el-radio-group v-model="form.showPlace" @change="onShowPlaceChange">
            <el-radio label="home">首页</el-radio>
            <el-radio label="user">个人中心</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="form.showPlace === 'home'"
          label="首页类型"
          prop="popupType"
          :rules="[{ required: true, message: '请选择类型' }]"
        >
          <el-select v-model="form.popupType" style="width:100%">
            <el-option v-for="item in homeTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="form.showPlace === 'user'"
          label="适用用户"
          prop="audience"
          :rules="[{ required: true, message: '请选择适用用户' }]"
        >
          <el-radio-group v-model="form.audience">
            <el-radio v-for="item in audienceList" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
          </el-radio-group>
          <div class="tip">普通用户 / VIP / 全部用户均可配置不同弹窗</div>
        </el-form-item>
        <el-form-item label="弹窗图片" prop="imgUrl" :rules="[{ required: true, message: '请上传图片' }]">
          <div id="uploadPopupImg" class="uploader uploader-warning"></div>
          <img v-if="form.imgUrl" :src="domain + form.imgUrl" style="height:50px;margin-left:10px" />
        </el-form-item>
        <el-form-item label="跳转链接"><el-input v-model="form.linkUrl" placeholder="小程序页面路径"></el-input></el-form-item>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="展示开始"><el-date-picker v-model="form.startDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="展示结束"><el-date-picker v-model="form.endDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker></el-form-item></el-col>
        </el-row>
        <template v-if="form.showPlace === 'home' && (form.popupType == 2 || form.popupType == 3)">
          <el-row :gutter="16">
            <el-col :span="12"><el-form-item label="报名开始"><el-date-picker v-model="form.examRegisterStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker></el-form-item></el-col>
            <el-col :span="12"><el-form-item label="报名结束"><el-date-picker v-model="form.examRegisterEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"></el-date-picker></el-form-item></el-col>
          </el-row>
          <el-form-item label="考试日期"><el-date-picker v-model="form.examDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width:280px"></el-date-picker></el-form-item>
        </template>
        <el-form-item v-if="form.showPlace === 'home' && form.popupType == 4" label="节日代码"><el-input v-model="form.holidayCode" placeholder="如 spring_festival"></el-input></el-form-item>
        <el-row :gutter="16">
          <el-col :span="12"><el-form-item label="每日一次"><el-switch v-model="form.showOncePerDay"></el-switch></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="排序"><el-input v-model.number="form.sort"></el-input></el-form-item></el-col>
        </el-row>
        <el-form-item label="启用"><el-switch v-model="form.isEnable"></el-switch></el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      key: "",
      query: { popupType: "0" },
      typeList: [],
      audienceList: [],
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dialogVisible: false,
      submiting: false,
      form: {}
    };
  },
  computed: {
    /** 首页子类型（排除个人中心） */
    homeTypeList() {
      return (this.typeList || []).filter(function (t) { return t.id != 5; });
    }
  },
  created() {
    $.get(url.getMiniManage("GetSelList_PopupType"), {}, res => { this.typeList = res || []; });
    $.get(url.getMiniManage("GetSelList_PopupAudience"), {}, res => { this.audienceList = res || []; });
    this.getList();
  },
  methods: {
    api(a) { return url.getMiniManage(a); },
    typeName(id) {
      var item = (this.typeList || []).find(function (t) { return t.id == id; });
      return item ? item.name : id;
    },
    audienceName(id) {
      var item = (this.audienceList || []).find(function (t) { return t.id == id; });
      return item ? item.name : (id === 0 || id == null ? "全部用户" : id);
    },
    handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.getList(); },
    handleCurrentChange(val) { this.currentPage = val; this.getList(); },
    selClick() { this.currentPage = 1; this.getList(); },
    /** tabs: 0全部 / home=首页全部子类型 / 5个人中心 / 1~4具体首页类型 */
    resolveListPopupType() {
      var t = this.query.popupType;
      if (t === "home") return -1; // 前端过滤：非个人中心
      return parseInt(t, 10) || 0;
    },
    getList() {
      this.loading = true;
      var listType = this.resolveListPopupType();
      var apiType = listType === -1 ? 0 : listType;
      $.get(this.api("GetList_HomePopup"), {
        key: this.key,
        popupType: apiType,
        pageindex: this.currentPage,
        pagesize: this.pageSize
      }, data => {
        this.loading = false;
        var list = data.list || [];
        if (listType === -1) {
          list = list.filter(function (r) { return r.popupType != 5; });
        }
        this.tableData = list;
        this.total = listType === -1 ? list.length : data.total;
      });
    },
    onShowPlaceChange(place) {
      if (place === "user") {
        this.$set(this.form, "popupType", 5);
        if (this.form.audience == null || this.form.audience === "") {
          this.$set(this.form, "audience", 0);
        }
      } else {
        if (this.form.popupType == 5) this.$set(this.form, "popupType", 1);
        this.$set(this.form, "audience", 0);
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate(["popupType", "audience"]);
      });
    },
    addClick() {
      const now = new Date();
      const end = new Date(now.getTime() + 7 * 24 * 3600 * 1000);
      this.form = {
        isEnable: true,
        showOncePerDay: true,
        needSubscribe: false,
        showPlace: "home",
        popupType: 1,
        audience: 0,
        sort: 0,
        startDate: this.formatDateTime(now),
        endDate: this.formatDateTime(end),
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    editClick(row) {
      // showPlace 必须一并写入，否则 Vue2 后加字段非响应式，编辑时切换无效
      this.form = Object.assign({}, row, {
        needSubscribe: false,
        showPlace: row.popupType == 5 ? "user" : "home",
        audience: row.audience != null ? row.audience : 0,
        startDate: this.formatDateTime(row.startDate),
        endDate: this.formatDateTime(row.endDate),
        examRegisterStart: this.formatDateTime(row.examRegisterStart),
        examRegisterEnd: this.formatDateTime(row.examRegisterEnd),
        examDate: this.formatDateTime(row.examDate),
      });
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    formatDateTime(val) {
      if (!val) return null;
      var d = val instanceof Date ? val : new Date(val);
      if (isNaN(d.getTime())) return typeof val === "string" ? val : null;
      var p = n => (n < 10 ? "0" + n : "" + n);
      return d.getFullYear() + "-" + p(d.getMonth() + 1) + "-" + p(d.getDate())
        + " " + p(d.getHours()) + ":" + p(d.getMinutes()) + ":" + p(d.getSeconds());
    },
    delClick(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" }).then(() => {
        $.post(this.api("Delete_HomePopup"), { id: row.id }, res => {
          if (res.status) { this.getList(); this.$message.success(res.msg); }
          else this.$message.error(res.msg);
        });
      }).catch(() => {});
    },
    dialogOpened() {
      var _this = this;
      if ($("#uploadPopupImg input").length == 0) {
        $("#uploadPopupImg").uploader({
          url: url.getUpload(), text: "上传图片", fileExts: "jpg;png", handleType: "0", maxSize: 1024 * 1024 * 2,
          onSuccess(data) { _this.$set(_this.form, "imgUrl", data.relativeName); }
        });
      }
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        if (this.form.showPlace === "user") {
          this.form.popupType = 5;
        } else if (this.form.popupType == 5) {
          this.$message.warning("请选择首页类型");
          return;
        } else {
          this.form.audience = 0;
        }
        this.submiting = true;
        var payload = Object.assign({}, this.form, { needSubscribe: false, subscribeTemplateId: "" });
        delete payload.showPlace;
        $.post(this.api("Save_HomePopup"), payload, res => {
          this.submiting = false;
          if (res.status) { this.dialogVisible = false; this.getList(); this.$message.success(res.msg); }
          else this.$message.error(res.msg);
        });
      });
    }
  }
};
</script>

<style scoped>
.query-form { margin-top: 20px; padding-top: 25px; background: #f2f2f2; }
.tip { color: #909399; font-size: 12px; line-height: 1.4; margin-top: 6px; }
.muted { color: #c0c4cc; }
</style>
